import "./Modal.scss";
import Button from "core/buttons/button/Button";
import Icon from "core/icon/Icon";
import InfoContext from "pages/InfoContext";
import InputRadioGroup from "core/inputs/input-radio/InputRadioGroup";
import ReactDom from "react-dom";
import { BACKUP_OPTIONS, BACKUP_VALUES } from "constants/constants";
import { FormattedMessage, useIntl } from "react-intl";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const BackupModal = ({ open, onClose, setMissionCreated }) => {
  const [value, setValue] = useState(BACKUP_VALUES.DOUBLE_BILLING);
  const intl = useIntl();
  const navigate = useNavigate();
  const { userScope, missionById } = useContext(InfoContext);

  const onValidate = () => {
    switch (value) {
      case BACKUP_VALUES.DOUBLE_BILLING:
        navigate(`/${userScope}/missions/creation`);
        break;
      case BACKUP_VALUES.DEFINITIVE_BACKUP:
        navigate(
          `/${userScope}/missions/${missionById?.slug}/definitive-backup`
        );
        break;
      case BACKUP_VALUES.TEMPORARY_BACKUP:
        navigate(
          `/${userScope}/missions/${missionById?.slug}/temporary-backup`
        );
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    setMissionCreated({});
  }, []);

  if (!open) return null;
  return ReactDom.createPortal(
    <>
      <div className="overlay-style" />
      <div className="backup-modal-style">
        <div className="header">
          <div className="title">
            {intl
              .formatMessage({
                id: "backup",
                defaultMessage: "Backup",
              })
              .toUpperCase()}
          </div>
          <Icon color="gray-200" icon="close" onClick={onClose} />
        </div>
        <div className="body">
          <InputRadioGroup
            id="backup-modal"
            isInline={false}
            options={BACKUP_OPTIONS.map((elm) => ({
              val: elm.val,
              lb: intl.formatMessage(elm.lb),
            }))}
            getSelectedValue={(e) => setValue(e?.target?.value)}
            value={value}
          />
          <div className="form-buttons">
            <Button
              className="btn-standard btn-outline"
              onClick={onClose}
              type="button"
              id="button-form-reset"
            >
              <FormattedMessage id="cancel" defaultMessage="Annuler" />
            </Button>
            <Button
              color="btn-medium gray-700"
              type="submit"
              onClick={onValidate}
              id="button-form-validation"
            >
              <FormattedMessage id="validate" defaultMessage="Valider" />
            </Button>
          </div>
        </div>
      </div>
    </>,
    document.getElementById("portal")
  );
};

export default BackupModal;
